import BackgroundVideo from "./BackgroundVideo";
import { buildWhatsAppLink, SITE_CONFIG } from "@/config/site";
import { track } from "@/lib/analytics";

export default function FinalCTA() {
  const whatsapp = buildWhatsAppLink();

  return (
    <section className="grain relative overflow-hidden bg-foreground-950 py-24 md:py-36">
      {/* Vídeo gastronômico de fundo full-bleed com overlay escuro */}
      <BackgroundVideo
        src="/videos/cta.mp4"
        poster="https://readdy.ai/api/search-image?query=Overhead%20spread%20of%20gourmet%20dishes%20burgers%20pizza%20and%20cocktails%20arranged%20on%20a%20dark%20charcoal%20table%20warm%20orange%20rim%20lighting%20cinematic%20moody%20food%20photography%20high%20detail%20premium%20dark%20aesthetic&width=1600&height=900&seq=playmenu-cta-bg-01&orientation=landscape"
        overlayClassName="bg-foreground-950/88"
      >
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,oklch(var(--primary-500)/0.18),transparent_60%)]" />
      </BackgroundVideo>

      <div className="relative z-10 mx-auto max-w-4xl px-4 text-center md:px-6">
        <span className="reveal mb-6 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-accent-500">
          <span className="h-px w-6 bg-current" />
          A decisão é agora
          <span className="h-px w-6 bg-current" />
        </span>

        <h2 className="reveal font-heading text-4xl font-bold leading-[1.05] tracking-tight text-foreground-50 md:text-6xl">
          Seu próximo cliente pode estar{" "}
          <span className="text-primary-500">escolhendo o que pedir agora.</span>
        </h2>

        <p className="reveal mx-auto mt-6 max-w-2xl text-base leading-relaxed text-foreground-300 md:text-lg">
          Faça ele desejar o seu produto antes mesmo de provar.
        </p>

        <div className="reveal mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <a
            href="https://playmenu.app/cadastro?tipo=restaurante"
            target="_blank"
            rel="noopener"
            onClick={() => track("hero_cta_click", { cta: "final" })}
            className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-full bg-primary-500 px-9 py-4 text-base font-semibold text-foreground-950 shadow-[0_0_40px_-8px_oklch(var(--primary-500)/0.6)] transition-all hover:bg-primary-400 hover:scale-[1.02] sm:w-auto"
          >
            Experimentar 3 vídeos grátis
            <i className="ri-arrow-right-line ml-2 text-lg" aria-hidden="true" />
          </a>
          <a
            href={whatsapp}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => track("whatsapp_click", { location: "final_cta" })}
            className="inline-flex w-full items-center justify-center whitespace-nowrap gap-2 rounded-full border border-foreground-600 px-9 py-4 text-base font-semibold text-foreground-50 transition-colors hover:border-foreground-400 hover:bg-foreground-800/40 sm:w-auto"
          >
            <i className="ri-whatsapp-line text-lg" aria-hidden="true" />
            Falar com o Play Menu
          </a>
        </div>

        <a
          href={SITE_CONFIG.instagramUrl}
          target="_blank"
          rel="nofollow noopener noreferrer"
          onClick={() => track("instagram_click", { location: "final_cta" })}
          className="reveal mt-8 inline-flex items-center gap-2 text-sm font-medium text-foreground-400 transition-colors hover:text-foreground-100"
        >
          <i className="ri-instagram-line text-lg" aria-hidden="true" />
          Acompanhe a Play Menu em {SITE_CONFIG.instagramHandle}
        </a>
      </div>
    </section>
  );
}